<div mat-dialog-title class="title-container" data-testid="dialog-title">
  <div>
    <ng-content></ng-content>
  </div>

  <button mat-icon-button mat-dialog-close class="title-close-button" disableRipple>
    <mat-icon>close</mat-icon>
  </button>
</div>
